import { toast } from "react-toastify";
import { executePost } from "../../../Utils/ServiceMethods";
import { SessionTimeout } from "../../../Utils/ErrorMessages";
import { removeUserCredentials } from "../../../Utils/LocalStorage";

export const BusinessListingPlus = async (data, cb) => {
  try {
    const BusinessListingPlus = await executePost(
      "/businesslistingPlusMore",
      data
    );
    const BusinessListingPlusData = BusinessListingPlus.data
      ? BusinessListingPlus.data
      : [];
    return BusinessListingPlusData;
  } catch (error) {
    if (error.response.data.message === "Token is invalid!") {
      toast.dismiss();
      toast.clearWaitingQueue();
      toast.error(SessionTimeout, {
        position: "top-center",
        width: "500px",
        autoClose: 6000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
      removeUserCredentials();
      if (cb) {
        cb();
      }
    } else {
      return false;
    }
  }
};
